module.exports = __webpack_public_path__ + "img/2.d7908c9b.jpg";